var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileOrdersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "55px",
    viewBox: "0 0 44 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000290697674 0.454186047 73.3828488 0.454186047 73.3828488 73.8372093 0.000290697674 73.8372093"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Simple-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-347.000000, -1356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(327.000000, 1346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.127326)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.6450581,64.307907 L22.7380814,64.307907 C21.2956395,64.307907 20.1218023,63.1340698 20.1218023,61.6916279 L20.1218023,12.8544186 C20.1218023,11.4119767 21.2956395,10.2381395 22.7380814,10.2381395 L50.6450581,10.2381395 C52.0875,10.2381395 53.2613372,11.4119767 53.2613372,12.8544186 L53.2613372,16.3427907 L51.5171512,16.3427907 L51.5171512,12.8544186 C51.5171512,12.3736047 51.1258721,11.9823256 50.6450581,11.9823256 L22.7380814,11.9823256 C22.2572674,11.9823256 21.8659884,12.3736047 21.8659884,12.8544186 L21.8659884,61.6916279 C21.8659884,62.1724419 22.2572674,62.5637209 22.7380814,62.5637209 L50.6450581,62.5637209 C51.1258721,62.5637209 51.5171512,62.1724419 51.5171512,61.6916279 L51.5171512,58.2032558 L53.2613372,58.2032558 L53.2613372,61.6916279 C53.2613372,63.1340698 52.0875,64.307907 50.6450581,64.307907",
    id: "Fill-4",
    fill: "#435FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2380814,17.7962791 C35.2380814,16.9933721 35.8886628,16.3427907 36.6915698,16.3427907 C37.4944767,16.3427907 38.1450581,16.9933721 38.1450581,17.7962791 C38.1450581,18.599186 37.4944767,19.2497674 36.6915698,19.2497674 C35.8886628,19.2497674 35.2380814,18.599186 35.2380814,17.7962791",
    id: "Fill-6",
    fill: "#435FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7438953,17.7962791 C39.7438953,17.3951163 40.0694767,17.0695349 40.4706395,17.0695349 C40.8718023,17.0695349 41.1973837,17.3951163 41.1973837,17.7962791 C41.1973837,18.1974419 40.8718023,18.5230233 40.4706395,18.5230233 C40.0694767,18.5230233 39.7438953,18.1974419 39.7438953,17.7962791",
    id: "Fill-8",
    fill: "#435FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9241279,59.0753488 L31.4590116,59.0753488 C30.9776163,59.0753488 30.5869186,58.6846512 30.5869186,58.2032558 C30.5869186,57.7218605 30.9776163,57.3311628 31.4590116,57.3311628 L41.9241279,57.3311628 C42.4055233,57.3311628 42.7962209,57.7218605 42.7962209,58.2032558 C42.7962209,58.6846512 42.4055233,59.0753488 41.9241279,59.0753488",
    id: "Fill-10",
    fill: "#435FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4357558,27.68 C37.9549419,27.68 37.5636628,28.0712791 37.5636628,28.552093 L37.5636628,51.2265116 C37.5636628,51.7073256 37.9549419,52.0986047 38.4357558,52.0986047 L61.1101744,52.0986047 C61.5909884,52.0986047 61.9822674,51.7073256 61.9822674,51.2265116 L61.9822674,28.552093 C61.9822674,28.0712791 61.5909884,27.68 61.1101744,27.68 L38.4357558,27.68 Z M61.1101744,53.8427907 L38.4357558,53.8427907 C36.993314,53.8427907 35.8194767,52.6689535 35.8194767,51.2265116 L35.8194767,28.552093 C35.8194767,27.1096512 36.993314,25.935814 38.4357558,25.935814 L61.1101744,25.935814 C62.5526163,25.935814 63.7264535,27.1096512 63.7264535,28.552093 L63.7264535,51.2265116 C63.7264535,52.6689535 62.5526163,53.8427907 61.1101744,53.8427907 L61.1101744,53.8427907 Z",
    id: "Fill-12",
    fill: "#435FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4938953,26.807907 L56.7497093,26.807907 C56.7497093,24.4032558 54.7938953,22.4474419 52.3892442,22.4474419 L47.156686,22.4474419 C44.7520349,22.4474419 42.7962209,24.4032558 42.7962209,26.807907 L41.0520349,26.807907 C41.0520349,23.4416279 43.790407,20.7032558 47.156686,20.7032558 L52.3892442,20.7032558 C55.7555233,20.7032558 58.4938953,23.4416279 58.4938953,26.807907",
    id: "Fill-14",
    fill: "#435FF7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOrdersIcon);
export default __webpack_public_path__ + "static/media/mobile_orders_icon.95be87802a5e2d03d777d8a4abfcde47.svg";
export { ForwardRef as ReactComponent };